//Entry point.  You should not really need to make changes to this file unless adding a Vue plugin .etc...
import Vue from "vue";
import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
